import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfinity = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.25 8.5C3.21839 8.5 1.5 10.3951 1.5 12.25C1.5 14.1049 3.21839 16 5.25 16C6.26678 16 7.26414 15.5434 8.3116 14.7468C9.20229 14.0694 10.0701 13.193 10.9672 12.25C10.0701 11.307 9.20229 10.4306 8.3116 9.75321C7.26414 8.95655 6.26678 8.5 5.25 8.5ZM12 11.1592C11.1126 10.2275 10.1874 9.29533 9.21965 8.55929C8.04836 7.66845 6.73322 7 5.25 7C2.34258 7 0 9.61487 0 12.25C0 14.8851 2.34258 17.5 5.25 17.5C6.73322 17.5 8.04836 16.8316 9.21965 15.9407C10.1874 15.2047 11.1126 14.2725 12 13.3408C12.8874 14.2725 13.8126 15.2047 14.7803 15.9407C15.9516 16.8316 17.2668 17.5 18.75 17.5C21.6574 17.5 24 14.8851 24 12.25C24 9.61487 21.6574 7 18.75 7C17.2668 7 15.9516 7.66845 14.7803 8.55929C13.8126 9.29533 12.8874 10.2275 12 11.1592ZM13.0328 12.25C13.9299 13.193 14.7977 14.0694 15.6884 14.7468C16.7359 15.5434 17.7332 16 18.75 16C20.7816 16 22.5 14.1049 22.5 12.25C22.5 10.3951 20.7816 8.5 18.75 8.5C17.7332 8.5 16.7359 8.95655 15.6884 9.75321C14.7977 10.4306 13.9299 11.307 13.0328 12.25Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgInfinity;
